import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import 'moment-timezone';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { TipusFixatge } from './TipusFixatge';
import moment from 'moment';

// Llegeix directament de cp.detallSetmana (ja carregat per HoresTotalsSetmana)
// 0 crides HTTP addicionals

export const LlistatFixatgesDia = ({ dataAvui }) => {
  const [t] = useTranslation('generic');
  const { cp } = useSelector(state => ({ cp: state.cp }));

  const diaStr = moment(dataAvui).format('YYYY-MM-DD');

  const listItems = useMemo(() => {
    const diaData = cp?.detallSetmana?.fixatges_setmanals?.find(d => d.dia === diaStr);
    if (!diaData?.fixatges?.length) return null;
    return diaData.fixatges.map(d => (
      <li className='list-checked-item' key={d.IdFixatge}>
        <TipusFixatge
          idTipusFixatge={Number(d.IdTipus_Fixatge)}
          idTipusIncidencia={Number(d.IdTipusIncidencia_Fixatge)}
        /> - <Moment format="HH:mm" date={d.DataHora_Fixatge} />
      </li>
    ));
  }, [cp?.detallSetmana, diaStr]);

  return (
    <>
      <hr />
      <h4 className="card-title mt-3">
        {t('ControlPresencia_LlistatFixatgesDia.title')} <Moment format="DD/MM/YYYY" date={dataAvui} />
      </h4>
      <ul className='list-checked list-checked-soft-bg-primary list-checked-lg mb-6 mt-4'>
        {listItems}
      </ul>
    </>
  );
};

LlistatFixatgesDia.propTypes = {
  dataAvui: PropTypes.instanceOf(Date)
};